export const DTableState = wcardinal.ui.DTableState;